import {
  faqs,
  howItWorks,
  WinnipegJetsLink,
  purchaseCreditLanguages,
  WinnipegJetsHamburgerTCListItems,
} from "./helpers";
import { routes } from "@/global/routes";
import { vendorUUIDs } from "../../constants";
import {
  DefaultRegistrationTerms,
  DefaultCheckoutTerms,
} from "../../default_terms_and_conditions";

import SeatMap3dPreview from "public/images/winnipegjets_flex/SSbackgroundimage.jpg";
import AuthBackgroundBanner from "public/images/winnipegjets_flex/SSbackgroundimage.jpg";
import FindGamesBanner from "public/images/winnipegjets_flex/2425JETS013-4002_BizPass_Marketing-Assets_1486x148_v1.jpg";

import type { TeamConfig } from "../types";

const LogoImage =
  "https://ss-leagues.s3.amazonaws.com/NHL_2024_v3/jets-assets/Primary%20Logo/NHL_Jets_Primary.png";

const config: TeamConfig = {
  teamSchema: "winnipegjets_bizpassport",
  browserTitle: "Winnipeg Jets Business Passport",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  teamName: "Winnipeg Jets",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-ca-10006-jets-sec",
    mapId: "main",
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.redeem,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: true,
    isStandAlonePurchaseCreditEnabled: true,
    showPurchaseCreditLinkInHomeMenu: true,
    isPurchaseCreditHistoryEnabled: true,
  },

  // disabled routes
  disabledRoutes: [routes.giftCard],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: true,
  isCrowdHandlerEnabled: true,
  inventoryType: "SEAT-LEVEL",

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: true,
    allowManualCartInSimilar: true,
    isCheckoutEditSeatsEnabled: true,
    isDiffSeatAlertEnabled: true,
    isPerksEnabled: false,
    hideViewTicketsInThankYouPage: false,
    defaultSeatCount: 2,
    checkoutTimerEnabled: false,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },

  isSaveCardAllowed: true,
  oktaClientId: "",
  oktaIssuer: "",
  refreshInventoryWhenEventClick: false,
  platform: vendorUUIDs.ticketmaster,

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
  },

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "https://flex2.seasonshare.com/winnipegjets_passport",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/tnse/",

  // images
  images: {
    findGamesBannerImage: FindGamesBanner.src,
    authBackgroundImage: AuthBackgroundBanner.src,
    checkoutStatusPageImage: AuthBackgroundBanner.src,
    logoImage: LogoImage + "?width=84&height=66",
    logoNameImage: "",
    faviconImage: LogoImage,
    seatMap3dPreviewImage: SeatMap3dPreview.src,
  },

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },

    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: false,
    },

    bottomBar: {
      showGameSelectionProgress: false,
    },

    purchaseCredit: {
      purchaseCreditTitle: "Purchase Passport",
      checkoutCreditButtonText: "Purchase Passport",
      checkoutCreditModalTitle: "Add Passport",
    },

    checkoutPage: {
      zipCodePlaceholder: "Postal Code",
    },
  },

  colors: {
    primary: "#041E42",
  },

  howItWorks: howItWorks,
  faqs: faqs,

  languages: {
    topNavMenuItems: <WinnipegJetsHamburgerTCListItems />,
    checkoutTermsAndCondition: <DefaultCheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    purchaseSeats: null,
    purchaseGiftCard: null,
    redeemGiftCard: null,
    purchaseCredit: purchaseCreditLanguages,

    checkoutSuccessDescription: (
      <>
        Tickets are now available to view in your TN Ticket Central{" "}
        <WinnipegJetsLink />!
      </>
    ),

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description: "",
          },
          sendNowTrue: {
            description: "",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description: "",
        },
        logout: {
          description: "",
        },
        success: {
          description: "",
        },
      },
    },

    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
